/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { data_ninth_armies } from '../models/data_ninth_armies';
import type { data_ninth_army } from '../models/data_ninth_army';
import type { data_ninth_banners } from '../models/data_ninth_banners';
import type { data_ninth_deployments } from '../models/data_ninth_deployments';
import type { data_ninth_magic_paths } from '../models/data_ninth_magic_paths';
import type { data_ninth_maps } from '../models/data_ninth_maps';
import type { data_ninth_objectives } from '../models/data_ninth_objectives';
import type { data_ninth_organisations } from '../models/data_ninth_organisations';
import type { data_ninth_special_items } from '../models/data_ninth_special_items';
import type { data_ninth_unit } from '../models/data_ninth_unit';
import type { data_ninth_units } from '../models/data_ninth_units';
import type { data_ninth_versions } from '../models/data_ninth_versions';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DataAnalyticsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Ninth Age Army
   * @returns data_ninth_army successful
   * @throws ApiError
   */
  public getNinthAgeArmy({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    id: number;
  }): CancelablePromise<data_ninth_army> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_age/armies/{id}',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
  /**
   * Get Ninth Age Deployments
   * @returns data_ninth_deployments successful
   * @throws ApiError
   */
  public getDeployments({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<data_ninth_deployments> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_ages/deployments.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get Ninth Age Objectives
   * @returns data_ninth_objectives successful
   * @throws ApiError
   */
  public getObjectives({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<data_ninth_objectives> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_ages/objectives.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get Ninth Age Unit
   * @returns data_ninth_unit successful
   * @throws ApiError
   */
  public getNinthAgeUnit({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Unit identifier
     */
    id: number;
  }): CancelablePromise<data_ninth_unit> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_age/units/{id}',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
  /**
   * Get Ninth Age Versions
   * @returns data_ninth_versions successful
   * @throws ApiError
   */
  public getVersions({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<data_ninth_versions> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_ages/versions.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get Ninth Age Armies
   * @returns data_ninth_armies successful
   * @throws ApiError
   */
  public dataAnalyticGetArmies({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<data_ninth_armies> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_ages/armies.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get Ninth Age Organisations
   * @returns data_ninth_organisations successful
   * @throws ApiError
   */
  public getOrganisations({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<data_ninth_organisations> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_ages/organisations.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get Ninth Age Units
   * @returns data_ninth_units successful
   * @throws ApiError
   */
  public getUnits({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<data_ninth_units> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_ages/units.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get Ninth Age Magic Paths
   * @returns data_ninth_magic_paths successful
   * @throws ApiError
   */
  public getMagicPaths({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<data_ninth_magic_paths> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_ages/magic_paths.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get Ninth Age Special Items
   * @returns data_ninth_special_items successful
   * @throws ApiError
   */
  public getSpecialItems({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<data_ninth_special_items> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_ages/special_items.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get Ninth Age Banners
   * @returns data_ninth_banners successful
   * @throws ApiError
   */
  public getBanners({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<data_ninth_banners> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_ages/banners.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get Ninth Age Maps
   * @returns data_ninth_maps successful
   * @throws ApiError
   */
  public getMaps({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<data_ninth_maps> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/data_analytics/ninth_ages/maps.json',
      path: {
        locale: locale,
      },
    });
  }
}
